/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import CheckBox from "../../../../../shared-ui/checkbox";
import InputField from "../../../../../shared-ui/input-field";
// import "react-accessible-accordion/dist/fancy-example.css";

interface SearchSelectComponentProps {
  questionType: string;
  questionValue: string;
  questionTitle: string;
  optionList: any;
  optionsListWithAnswer: any;
  dependent: any;
  disableAllAnswers: boolean;
  handleInputChange?: (
    questionType: string,
    questionValue: string,
    questionTitle: string,
    answer: any,
    isNeedState: boolean,
    isDependent: boolean,
    dependentQuestions: any
  ) => void;
}

interface SearchSelectComponentState {
  listOfOptions: any;
  inputValue: string;
  openList: boolean;
  questionTitleState: string;
}
class SearchSelectComponent extends React.Component<
  SearchSelectComponentProps,
  SearchSelectComponentState
> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      listOfOptions: [],
      inputValue: "",
      openList: false,
      questionTitleState: "",
    };
  }

  componentDidMount = () => {
    const { questionTitle, questionValue, optionList, disableAllAnswers } =
      this.props;

    if (this.props.optionsListWithAnswer !== undefined) {
      this.setState({
        listOfOptions: this.props.optionsListWithAnswer,
        openList: true,
      });
    } else {
      let data = [...optionList];
      data.forEach(function (item: {
        isChecked: boolean;
        isDisabled: boolean;
      }) {
        item.isChecked = false;
        item.isDisabled = false;
      });

      if (questionValue === "Allergy") {
        data.unshift({
          id: "None",
          isChecked: false,
          isDisabled: false,
          value: "No Allergies",
        });
      }
      if (questionValue === "FoodDislikes") {
        data.unshift({
          id: "None",
          isChecked: false,
          isDisabled: false,
          value: "No Dislikes",
        });
      }
      this.setState({
        listOfOptions: data,
      });
    }
  };

  componentDidUpdate = () => {
    const { questionValue, optionList, optionsListWithAnswer } = this.props;
    if (this.props.questionTitle !== this.state.questionTitleState || (this.props.optionsListWithAnswer !== undefined && this.state.listOfOptions !== this.props.optionsListWithAnswer)) {
      this.setState({
        questionTitleState: this.props.questionTitle,
      });
      const { questionTitle, questionValue, optionList } = this.props;

      if (this.props.optionsListWithAnswer !== undefined) {
        this.setState({
          listOfOptions: this.props.optionsListWithAnswer,
          openList: true,
        });
      } else {
        let data = [...optionList];
        data.forEach(function (item: {
          isChecked: boolean;
          isDisabled: boolean;
        }) {
          item.isChecked = false;
          item.isDisabled = false;
        });

        if (questionValue === "Allergy") {
          data.unshift({
            id: "None",
            isChecked: false,
            isDisabled: false,
            value: "No Allergies",
          });
        }
        if (questionValue === "FoodDislikes") {
          data.unshift({
            id: "None",
            isChecked: false,
            isDisabled: false,
            value: "No Dislikes",
          });
        }
        this.setState({
          listOfOptions: data,
        });
      }
    }
  };

  handleDropDownSearch = (evt: any) => {
    this.setState(
      {
        ...this.state,
        inputValue: evt.target.value,
        openList: true,
      },
      () => {
        //this.props.inputValue(evt);
      }
    );
  };
  handleOutsideClick = (e: any) => {
    e.stopPropagation();

    this.node && this.node.scrollTo(0, 0);
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.setState({
      openList: false,
      inputValue: "",
    });
  };

  handleDropDown = (e: any) => {
    e.stopPropagation();
    if (this.state.openList === false) {
      this.setState({ openList: true });
    }

    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("keydown", (e: any) => {
      if (e.key === "Escape") {
        this.handleOutsideClick(e);
      }
    });
  };

  getSelectedData = () => {
    let recoValues: Array<String> = [];
    if (!_.isEmpty(this.state.listOfOptions)) {
      _.map(this.state.listOfOptions, (data: any, index: any) => {
        if (data?.isChecked) {
          recoValues.push(data.id);
        }
      });
    }
    return recoValues;
  };

  handleCheckboxClick = (isChecked: boolean, value: string) => {
    const { listOfOptions } = this.state;
    const { questionValue, questionTitle, questionType, dependent } =
      this.props;
    const data: any = listOfOptions;
    const objIndex = data.findIndex((obj: any) => obj.value === value);
    data[objIndex].isChecked = isChecked;
    /*This code is used to handle disabling of options*/
    const uncheckedFilteredOptions = listOfOptions.filter(
      (obj: any) => obj.isChecked === false
    ).length;
    const allExceptNoneOptions = _.tail(data);
    const checkedFilteredOptions = allExceptNoneOptions.filter(
      (obj: any) => obj.isChecked === true
    ).length;
    if (objIndex === 0 && data[0].isChecked === true) {
      for (let i = 1; i < data.length; i = i + 1) {
        data[i].isDisabled = true;
      }
    }
    if (checkedFilteredOptions > 0) {
      data[0].isDisabled = true;
    }
    if (uncheckedFilteredOptions === listOfOptions.length) {
      data.forEach((element: any) => {
        element.isDisabled = false;
      });
    }

    const selectedValues: any = this.getSelectedData();
    let valuesFound = false;
    let dependentQuestions: any = [];
    if (dependent && dependent.length > 0) {
      const conditionsArray = dependent[0]?.conditions;
      let newArray = _.intersection(conditionsArray, selectedValues);
      valuesFound = newArray.length > 0 ? true : false;
      dependentQuestions = dependent[0]?.questions;
    }

    this.setState({ listOfOptions: data }, () => {
      if (this.props.handleInputChange) {
        this.props.handleInputChange(
          questionType,
          questionValue,
          questionTitle,
          listOfOptions,
          false,
          valuesFound,
          dependentQuestions
        );
      }
    });
  };

  render() {
    const { listOfOptions, inputValue, openList } = this.state;
    const { disableAllAnswers } = this.props;
    const filterDropdownData =
      inputValue && inputValue.trim() && inputValue.trim().length > 1
        ? listOfOptions.filter(
          (item: any) =>
            item &&
            item.value.toLowerCase() &&
            item.value
              .toLowerCase()
              .indexOf(
                inputValue.trim() && inputValue.trim().toLowerCase()
              ) !== -1
        )
        : listOfOptions;

    return (
      <div
        className={
          disableAllAnswers
            ? "answers-wrapper search-select-wrapper disabled"
            : "answers-wrapper search-select-wrapper"
        }
      >
        <div className="search-bar-wrapper" onClick={this.handleDropDown}>
          <InputField
            type={"text"}
            placeHolder={"Search"}
            className={"custom-input"}
            handleInputChange={(evt) => {
              this.handleDropDownSearch(evt);
            }}
            inputValue={inputValue || ""}
          />
          <div className={"icon search-icon"}></div>
        </div>
        <div
          id="drop"
          className={openList ? "options-area" : "hide"}
          ref={(node) => {
            this.node = node;
          }}
        >
          {filterDropdownData &&
            filterDropdownData.length > 0 &&
            filterDropdownData.map((option: any, index: number) => (
              <div
                className={
                  option && option.isDisabled ? "option disable" : "option"
                }
              >
                {/* <div className="radio-btn"> */}
                <CheckBox
                  className={"checkbox"}
                  onCheckboxClick={(event) => {
                    //event?.stopPropagation();
                    this.handleCheckboxClick(
                      event.target.checked,
                      option && option.value
                    );
                  }}
                  isChecked={option && option.isChecked}
                />
                {/* </div> */}
                <div className="option-label" onClick={(event) => {
                  //event?.stopPropagation();
                  this.handleCheckboxClick(
                    option && !option.isChecked,
                    option && option.value
                  );
                }}>{option?.value}</div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default SearchSelectComponent;
